import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 820px;
  gap: 20px;
`

export const Card = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  padding: 16px;
  background-color: #F7F7F7;
  border-radius: 15px;
  box-shadow: 0px 2px 10px -6px #252525;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Label = styled.label`
  margin: 0px;
  font-size: 14px;
  font-weight: 600;
  color: #252525;
`

export const BrandGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px 20px;
`

export const BrandRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  label {
    margin: 0px;
    cursor: pointer;
  }
`

export const OtherBrandRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  max-width: 460px;

  /* O input ocupa o espaço que sobra ao lado do botão; quando a largura não comporta
     os dois (min-width), o botão quebra para baixo. */
  & > div {
    flex: 1 1 200px;
    width: auto;
    min-width: 0;
  }

  & > button {
    flex: 0 0 auto;
  }
`

export const MachineRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  background-color: #F7F7F7;
  border-radius: 15px;
  box-shadow: 0px 2px 10px -6px #252525;

  &:hover {
    background-color: #EFEFEF;
  }
`

export const MachineItem = styled.button`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  gap: 2px;
  padding: 14px 16px;
  text-align: left;
  border: 0px;
  background-color: transparent;
  cursor: pointer;
`

export const DefaultBadge = styled.span`
  padding: 2px 10px;
  margin-left: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #252525;
  background-color: #FFC100;
  border-radius: 10px;
`

export const DefaultButton = styled(LookButton).attrs(buttonLook({ variant: 'secondary' }))`
  flex: 0 0 auto;
  margin-right: 12px;
`

export const MachineName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #252525;
`

export const HintText = styled.p`
  margin: 0px;
  font-size: 13px;
  color: #777777;
`

export const WarningText = styled.p`
  margin: 0px;
  font-size: 14px;
  color: #FF3939;
`

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const Table = styled.table`
  width: 100%;
  min-width: 560px;
  border-collapse: collapse;
`

export const HeaderCell = styled.th`
  padding: 8px;
  text-align: center;
  font-size: 14px;
  white-space: nowrap;
  background-color: ${({ $linked }) => $linked ? '#FFF3CC' : 'transparent'};
`

export const LabelCell = styled.td`
  padding: 4px 12px 4px 0px;
  text-align: right;
  font-size: 14px;
  white-space: nowrap;
`

export const ValueCell = styled.td`
  padding: 3px 4px;
  background-color: ${({ $linked }) => $linked ? '#FFF3CC' : 'transparent'};
`

export const FeeInput = styled(BaseInput)`
  width: 100%;
  min-width: 78px;
`

export const TermRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;

  label {
    margin: 0px;
    min-width: 64px;
    font-size: 14px;
  }
`

export const TermInput = styled(FeeInput)`
  width: 90px;
  min-width: 0;
`

export const TermSelect = styled(FeeInput).attrs({ as: 'select' })`
  width: auto;
  max-width: 100%;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`

export const ActionButton = styled(LookButton).attrs(buttonLook(({ $danger }) => ($danger ? { variant: 'primary', destructive: true } : { variant: 'secondary' })))`
  min-width: 120px;
`
